import {useMediaQuery, useTheme} from "@mui/material";

export const useBreakpoints = () => {
    const theme = useTheme();
    const desktopScreen = useMediaQuery(theme.breakpoints.down("xl")); //1536
    const laptopScreen = useMediaQuery(theme.breakpoints.down("lg")); //1200
    const screen1024 = useMediaQuery(theme.breakpoints.down("br1024")); //1024
    const tabletScreen = useMediaQuery(theme.breakpoints.down("md")); //900
    const screen768 = useMediaQuery(theme.breakpoints.down("br768")); //768
    const mobileBigScreen = useMediaQuery(theme.breakpoints.down("sm")); //600
    const screen480 = useMediaQuery(theme.breakpoints.down("br480")); //480
    const mobileMediumScreen = useMediaQuery(theme.breakpoints.down("mobM")); //420
    const mobileSmallScreen = useMediaQuery(theme.breakpoints.down("mobS")); //330

    return {
        desktopScreen,
        laptopScreen,
        screen1024,
        tabletScreen,
        screen768,
        mobileBigScreen,
        screen480,
        mobileMediumScreen,
        mobileSmallScreen,
    }
}